import styled from "styled-components";

export const MainBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const BannerTitBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  svg {
    path {
      fill: ${(props) => props.theme.colors.primary100};
    }
  }

  div {
    font-size: 2rem;
    font-weight: 500;
    font-family: "Pretendard";
    line-height: 140%;
  }
`;

export const ProfileCard = styled.div`
  display: flex;
  padding: 16px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 20px;
  flex-direction: column;
  gap: 16px;
`;

export const ProfileCardContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;

  & > div {
    display: flex;
    padding: 4px;
    align-items: center;
    gap: 16px;

    img {
      width: 44px;
      height: 44px;
      border-radius: 22px;
    }
  }
`;

export const ProfileCardTitle = styled.p`
  color: ${(props) => props.theme.colors.black38};
  font-size: 1.2rem;
  font-family: "Pretendard";
`;

export const ProfileInfo = styled.div`
  display: flex;
  font-family: "Pretendard";
  flex-direction: column;
  gap: 4px;

  & > span {
    font-size: 1.6rem;
    font-weight: 600;
  }

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      color: ${(props) => props.theme.colors.black60};
      font-size: 1.3rem;
      vertical-align: middle;

      & + span {
        position: relative;
        padding-left: 8px;

        &::before {
          position: absolute;
          content: "";
          display: block;
          height: 12px;
          left: 0;
          top: 2px;
          border-left: 1px solid ${(props) => props.theme.colors.black20};
        }
      }
    }
  }
`;
